import _toConsumableArray from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export default (function (value) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  value = value.replace(/\D/g, '');
  var m = value.match(/^(?:\d{0,1})(\d{3})(\d{3})(\d{4})$/);
  return m && ['1'].concat(_toConsumableArray(m.slice(1))).join(separator);
});